<template>
	<div
		:class="['select', { opened: opened }, { disabled: disable }]"
		:style="width ? 'width: ' + width + 'px' : ''"
		v-click-away="close"
	>
		<div
			:class="['select-item', value ? 'filled' : '']"
			@click="open($event)"
		>
			<template v-if="value">{{ selectedText }}</template>

			<img src="images/icons/chevron-down-green.svg" />
		</div>
		<label @click="open($event)">{{ label }}</label>
		<div class="select-list" v-show="opened">
			<div v-if="searchable" class="querry-field">
				<label :for="'Querry' + htmlId">
					<img src="images/search.svg" />
				</label>
				<input
					v-model="searchQuerry"
					:id="'Querry' + htmlId"
					@keyup="search($event)"
					type="text"
					autocomplete="new-password"
				/>
			</div>
			<div
				v-for="(item, i) in filteredList"
				:key="htmlId + i"
				@click="selectItem(item)"
			>
				{{ item.text }}
			</div>
			<div v-if="filteredList.length === 0" @click="resetSearch">
				Brak wyników (kliknij aby wyczyścić)
			</div>
		</div>
	</div>
</template>

<script>
import { getDictionaryItem } from '@/mixins/get-dictionary-item';
export default {
	data() {
		return {
			opened: false,
			selectedText: '',
			selectedListHeight: 0,
			filteredList: [],
			listString: '',
			searchQuerry: '',
		};
	},
	props: {
		htmlId: {
			type: String,
			required: true,
		},
		label: {
			type: String,
			required: true,
		},
		value: {
			type: String,
			required: false,
		},
		list: {
			type: Array,
			required: true,
		},
		width: {
			type: Number,
			required: false,
		},
		itemTypeToSave: {
			type: String,
			required: false,
		},
		change: {
			type: Function,
			required: false,
		},
		itemIndex: {
			type: Number,
			required: false,
			default: null,
		},
		searchable: {
			type: Boolean,
			required: false,
			default: false,
		},
		disable: {
			type: Boolean,
			required: false,
			default: false,
		},
	},
	mixins: [getDictionaryItem],
	methods: {
		open() {
			if (!this.disable) {
				this.opened = !this.opened;
			}

			if (this.htmlId == 'TaxOfficeId') {
				//Nie wiem czemu dla Adresu właściowego urzędu muszę wykonać to tutaj
				this.filteredList = this.list;
			}
		},
		close() {
			this.opened = false;
			this.searchQuerry = '';
			this.filteredList = this.list;
		},
		selectItem(item) {
			var mutationName = 'set' + this.htmlId;
			if (this.itemTypeToSave === 'text') {
				if (this.itemIndex != null) {
					mutationName = mutationName.replace(
						'_' + this.itemIndex,
						''
					);
					var dataObj = { index: this.itemIndex, value: item.text };
					this.$store.commit(mutationName, dataObj);
				} else {
					this.$store.commit(mutationName, item.text);
				}
			} else {
				if (this.itemIndex != null) {
					mutationName = mutationName.replace(
						'_' + this.itemIndex,
						''
					);
					var dataObj1 = {
						index: this.itemIndex,
						value: item.value,
						text: item.text,
					};
					this.$store.commit(mutationName, dataObj1);
				} else {
					this.$store.commit(mutationName, item.value);
				}
			}

			this.selectedText = this.getDictionaryItem(
				this.list,
				'text',
				'value',
				parseInt(item.value)
			);
			this.opened = false;
			this.searchQuerry = '';
			this.filteredList = this.list;

			this.$emit('change', item.value);
		},
		search(e) {
			let val = e.target.value;

			this.filteredList = this.list;
			this.filteredList = this.filteredList.filter(
				(item) =>
					item.text.toLowerCase().indexOf(val.toLowerCase()) !== -1
			);
		},
		resetSearch() {
			this.searchQuerry = '';
			this.filteredList = this.list;
		},
		displayLabel() {
			if (this.itemTypeToSave === 'text') {
				this.selectedText = this.getDictionaryItem(
					this.list,
					'text',
					'text',
					this.value
				);
			} else {
				this.selectedText = this.getDictionaryItem(
					this.list,
					'text',
					'value',
					parseInt(this.value)
				);
			}
		},
	},
	mounted() {
		this.displayLabel();
		this.filteredList = this.list;
		this.searchQuerry = '';
	},
	updated() {
		this.displayLabel();
	},
};
</script>
